import EventCard from './event-card-view';

export default EventCard;
